import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { IgrAssessmentAsinVerificationModalComponent } from '../igr-assessment-asin-verification-modal/igr-assessment-asin-verification-modal.component';
import { IgrAssessmentApplicationModalComponent } from '../igr-assessment-application-modal/igr-assessment-application-modal.component';
import { IgrAssessmentDetailsComponent } from '../igr-assessment-modal/igr-assessment-details/igr-assessment-details.component';
import { AuthService } from 'src/app/services/auth/auth.service';
import { environment } from 'src/environments/environment';
import { AdditionalIgrAssessmentModalComponent } from '../additional-igr-assessment-modal/additional-igr-assessment-modal.component';

enum View {
  MY_ASSESSMENTS = 'MY_ASSESSMENTS',
  ALL_ASSESSMENTS = 'ALL_ASSESSMENTS',
  PENDING_ASSESSMENTS = 'PENDING_ASSESSMENTS',
  ALL = 'ALL'
}
@Component({
  selector: 'app-igr-assessment-landing',
  standalone: false,
  templateUrl: './igr-assessment-landing.component.html',
  styleUrl: './igr-assessment-landing.component.scss'
})
export class IgrAssessmentLandingComponent {
  action_idx: any = null;

  dataList: any[] = [];
  form: FormGroup;

  isSearching: boolean = false;
  showSearchForm: boolean = false;

  searchedDataNotFound = false;
  isEmpty!: boolean;
  searched = false;
  isLoading: boolean = false;

  selectedStatus!: boolean;

  isDarkMode!: boolean;

  page: number = 0;
  num: number = 1;
  currentPage: number = 1;
  count: number = 0;
  pageSize: number = 10;
  selectedLimit: number = 10;



  View = View;
  activeTab: View;

  role: string;
  showTabs: boolean = true;
  @Output() onConfirmClicked = new EventEmitter();

  toggleShowSearch() {
    this.showSearchForm = !this.showSearchForm;
  }

  constructor(
    public fb: FormBuilder,
    private apiService: ApiService,
    private authService: AuthService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,

  ) { }

  ngOnInit(): void {
    this.role = this.authService.getRole();

    this.showTabs = this.hasAccess(['CAN_APPROVE_IGR_ASSESSMENT', 'CAN_QUERY_IGR_ASSESSMENT', 'CAN_CREATE_IGR_ASSESSMENT']);

    if (this.showTabs) {
      if (this.hasAccess(['CAN_APPROVE_IGR_ASSESSMENT'])) {
        this.activeTab = View.PENDING_ASSESSMENTS;
      }

      if (this.hasAccess(['CAN_CREATE_IGR_ASSESSMENT'])) {
        this.activeTab = View.MY_ASSESSMENTS;

      }
    }

    this.initializeSearchForm()

    this.getFilteredApplications();
    this.fetchAssessmentOfficers();

  }

  initializeSearchForm(){
    this.form = this.fb.group({
      assessmentId: [''],
      asin: [''],
      assessmentYear: [''],
      approvalStatus: [''],
      paymentStatus: [''],
      from: [''],
      to: [''],
      offset: [''],
      assessedBy: ['']
    });
  }

  getRowColor(type: string): any {
    switch (type) {
      case 'ADD_ASSESSMENT':
        return { background: '#d8e8bd' }

    }
  }

  hasAccess(permissions: string[]) {
    return this.authService.hasAnyPermission(permissions)
  }

  clearSearchFilters() {
    this.form.reset()
  }

  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getFilteredApplications()
    });
  }

  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => { });
  }




  demandNoticeDownloadId: any;
  receiptDownloadId: any;

  downloadDemandNotice(assessmentId) {
    this.demandNoticeDownloadId = assessmentId;
    let url = `/assessment/download/demand-notice?id=` + assessmentId;
    this.apiService
      .post(url, {}, { responseType: "blob" })
      .pipe(
        finalize(() => {
          this.demandNoticeDownloadId = false;
        })
      )
      .subscribe(
        (response: Blob) => {
          const blob = new Blob([response], { type: "application/pdf" });
          const blobUrl = window.URL.createObjectURL(blob);
          const file = new Blob([response], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          const downloadLink = document.createElement("a");
          downloadLink.href = blobUrl;
          downloadLink.target = "_blank";
          downloadLink.download = "demand-notice.pdf";
          downloadLink.click();

        },
        (error) => {
          this.openErrorModal("Error downloading demand notice");
        }
      );
  }

  fetchingAssessmentOfficers: boolean;
  assessmentOfficers: any[] = null;
  fetchAssessmentOfficers() {
    this.fetchingAssessmentOfficers = true
    this.apiService.get('/utility/user-by-permission?permission=CAN_CREATE_IGR_ASSESSMENT').subscribe((res: any) => {
      this.assessmentOfficers = res;
      this.fetchingAssessmentOfficers = false;
    })
  }


  downloadReceipt(assessmentId) {
    this.receiptDownloadId = assessmentId;
    let url = `/assessment/download/receipt?id=` + assessmentId;
    this.apiService
      .post(url, {}, { responseType: "blob" })
      .pipe(
        finalize(() => {
          this.receiptDownloadId = false;
        })
      )
      .subscribe(
        (response: Blob) => {
          const blob = new Blob([response], { type: "application/pdf" });
          const blobUrl = window.URL.createObjectURL(blob);
          const file = new Blob([response], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          const downloadLink = document.createElement("a");
          downloadLink.href = blobUrl;
          downloadLink.target = "_blank";
          downloadLink.download = "receipt.pdf";
          downloadLink.click();

        },
        (error) => {
          this.openErrorModal("Error downloading receipt");
        }
      );
  }






  setIsActive(tab: any) {

    this.activeTab = tab;

    this.page= 0;
    this.num = 1;
    this.currentPage = 1;
    this.count = 0;
    this.pageSize = 10;
    this.selectedLimit = 10;

     this.initializeSearchForm()

    this.getFilteredApplications()

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab },
      queryParamsHandling: 'merge',
    });
  }


  openActivateConfirmModal(id: number, name: string) {
    let dialogRef = this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: 'Activate Admin: ' + name + '?',
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {
          this.activateAdmin(id);
        },
        onCancel: () => {
          // dialogRef.close()
        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }

  openDeleteConfirmModal(assessment: any) {
    let dialogRef = this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: 'Delete assessment:',
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {
          this.deleteAssessment(assessment.id);
        },
        onCancel: () => {
          // dialogRef.close()
        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }

  deleteAssessment(id: number): void {
    this.isLoading = true;
    this.apiService
      .get(`/assessment/delete/${id}`)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        (response: any) => {
          this.openSuccessModal('Assessment deleted successfuly');
        },
        (error) => {
          this.openErrorModal(error?.message);
        }
      );
  }

  deactivateAdmin(id: number): void {
    this.isLoading = true;
    this.apiService
      .get(`/auth/user/deactivate/${id}`)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        (response: any) => {
          this.openSuccessModal('Admin deactivated successfuly');
        },
        (error) => {
          this.openErrorModal(error?.message);
        }
      );
  }

  activateAdmin(id: number): void {
    this.isLoading = true;
    this.apiService
      .get(`/auth/user/activate/${id}`)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        (response: any) => {
          this.openSuccessModal('Admin activated successfuly');
        },
        (error) => {
          this.openErrorModal(error?.message);
        }
      );
  }

  callDb(event: any) {
    this.currentPage = event;

    console.log(this.currentPage)
    this.page = event - 1;

    this.getFilteredApplications();
  }

  updateLimit() {
    this.currentPage = 1;

    this.page = 0;

    this.getFilteredApplications();
  }

  errorFetchingData: boolean = false;



  getFilteredApplications() {
    this.dataList = [];
    this.searchedDataNotFound = false;
    this.isSearching = true;
    this.errorFetchingData = false;

    this.pageSize = this.selectedLimit;

    this.num = this.page * this.selectedLimit;

    const searchAndFilterValues = this.form?.value;

    var filterParams: any = new FormData();

    const formValue = this.form.value;

    if (this.num != null) filterParams.append('offset', this.num);
    if (this.selectedLimit != null) filterParams.append('limit', this.selectedLimit);



    formValue.assessmentYear && filterParams.append("assessmentYear", formValue.assessmentYear);
    formValue.assessedBy && filterParams.append("assessedBy", formValue.assessedBy);
    formValue.asin && filterParams.append("asin", formValue.asin);
    formValue.approvalStatus && filterParams.append("approvalStatus", formValue.approvalStatus);
    formValue.paymentStatus && filterParams.append("paymentStatus", formValue.paymentStatus);
    formValue.from && filterParams.append("from", formValue.from);
    formValue.to && filterParams.append("to", formValue.to);

    filterParams.append("workflowName", "ASSESSMENT");

    const activeTab = this.activeTab;


    switch (activeTab) {
      case 'PENDING_ASSESSMENTS': {
        this.fetchPendingWorkflowLogs(filterParams, activeTab);
        break;
      }

      case 'ALL_ASSESSMENTS': {
        this.fetchAssessments(filterParams, activeTab);
        break
      }

      case 'MY_ASSESSMENTS': {
        this.fetchMyAssessments(filterParams, activeTab);
        break
      }


      default: {
        if (this.hasAccess(['CAN_CREATE_IGR_ASSESSMENT'])) {
          this.fetchWorkflowLogs(filterParams, activeTab);
          // this.fetchAssessments(filterParams, activeTab);

          return
        }

        this.fetchAssessments(filterParams, activeTab);
        return;
      }
    }
  }


  fetchWorkflowLogs(filterParams: FormData, activeTab: string) {
    this.apiService
      .post('/workflow/my/logs/page', filterParams)
      .pipe(
        finalize(() => {
          this.isSearching = false;
          this.isLoading = false;
        })
      )
      .subscribe(
        (response) => {
          this.dataList = response.data.map(item => ({ ...item, entity: { ...item.entity, id: item?.entity?.entityId, createdAt: item?.entity?.assessmentDate, amount: item?.entity?.grossIncome } }));

          this.count = response.totalElements;

          if (this.count == 0) {
            this.searchedDataNotFound = true;
          }
        },
        (error) => {
          this.openErrorModal(error?.message);
          this.errorFetchingData = true;
        }
      );
  }

  fetchPendingWorkflowLogs(filterParams: FormData, activeTab: string) {
    const formValue = this.form.value;
    formValue.assessmentId && filterParams.append("applicationId", formValue.assessmentId);

    this.apiService
      .post('/workflow/pending/logs/page', filterParams)
      .pipe(
        finalize(() => {
          this.isSearching = false;
          this.isLoading = false;
        })
      )
      .subscribe(
        (response) => {
          this.dataList = response.data.map(item => ({ ...item, entity: { ...item.entity, id: item?.entity?.entityId, createdAt: item?.entity?.assessmentDate, amount: item?.entity?.grossIncome } }));

          this.count = response.totalElements;

          if (this.count == 0) {
            this.searchedDataNotFound = true;
          }
        },
        (error) => {
          this.openErrorModal(error?.message);
          this.errorFetchingData = true;
        }
      );
  }




  fetchAssessments(filterParams: FormData, activeTab: string) {

    const formValue = this.form.value;
    formValue.assessmentId && filterParams.append("assessmentId", formValue.assessmentId);

    this.apiService
      .post('/assessment/page', filterParams)
      .pipe(
        finalize(() => {
          this.isSearching = false;
          this.isLoading = false;
        })
      )
      .subscribe(
        (response) => {

          this.dataList = response.data.map(item => ({ entity: { ...item, assessedBy: item?.createdBy }, currentApprover: item?.currentApprover, lgaName: item?.lgaName, assessedBy: item.createdBy }));
          this.count = response.totalElements;

          if (this.count == 0) {
            this.searchedDataNotFound = true;
          }
        },
        (error) => {
          this.openErrorModal(error?.message);
          this.errorFetchingData = true;
        }
      );
  }


  fetchMyAssessments(filterParams: FormData, activeTab: string) {

    const formValue = this.form.value;
    formValue.assessmentId && filterParams.append("assessmentId", formValue.assessmentId);

    this.apiService
      .post('/assessment/my/page', filterParams)
      .pipe(
        finalize(() => {
          this.isSearching = false;
          this.isLoading = false;
        })
      )
      .subscribe(
        (response) => {

          this.dataList = response.data.map(item => ({ entity: { ...item, assessedBy: item?.createdBy }, currentApprover: item?.currentApprover, lgaName: item?.lgaName, assessedBy: item.createdBy }));
          this.count = response.totalElements;

          if (this.count == 0) {
            this.searchedDataNotFound = true;
          }
        },
        (error) => {
          this.openErrorModal(error?.message);
          this.errorFetchingData = true;
        }
      );
  }

  splitPriviledges(privileges: String): string[] {
    return privileges?.split(',').map((item) => item.trim());
  }





  openViewModal(data: any) {
    console.log('data from landing', data)
    if (data.entity.id) {
      let dialog = this.dialog.open(IgrAssessmentDetailsComponent, {
        backdropClass: 'modal-form-backdrop',
        hasBackdrop: true,
        panelClass: ['modal-form', 'custom-dialog-xxl'],
        disableClose: true,

        data: { ...data.entity, workflowLogId: data.id },
      })

      dialog.afterClosed().subscribe((result) => {
        if (result) {
          this.getFilteredApplications();
        }
      });
    }
  }

  openEditModal(data: any) {
    let dialog = this.dialog.open(IgrAssessmentDetailsComponent, {
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'custom-dialog-xxl'],
      disableClose: true,

      data: { ...data.entity, isInPreviewMode: true, isEditingAllowed: true },
    })

    dialog.afterClosed().subscribe((result) => {
      if (result) {
        this.getFilteredApplications();
      }
    });
  }

  // openUpdateModal(data: any) {
  //   let dialog = this.dialog.open(IgrAssessmentAsinVerificationModalComponent, {
  //     width: '400px',
  //     backdropClass: 'modal-form-backdrop',
  //     hasBackdrop: true,
  //     panelClass: ['modal-form', 'custom-dialog-xl'],
  //     disableClose: true,

  //     data: { ...data, isInEditingMode: true },
  //   })

  // }



  openCreationModal(data: any) {
    let dialogRef = this.dialog.open(IgrAssessmentApplicationModalComponent, {
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'custom-dialog-xl'],
      disableClose: true,

      data: data,
    });


    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getFilteredApplications();
      }
    });
  }

  createAdditionalAssessment(data: any) {
    let dialogRef = this.dialog.open(AdditionalIgrAssessmentModalComponent, {
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'custom-dialog-xl'],
      disableClose: true,

      data: { ...data.entity, isInAdditionalAssessmentMode: true },
    });


    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getFilteredApplications();
      }
    });
  }

  openAsinVerificationModal() {
    let dialogRef = this.dialog.open(IgrAssessmentAsinVerificationModalComponent, {
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      disableClose: true,
      panelClass: ['modal-form', 'custom-dialog-md'],
    });

    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        this.openCreationModal(data)
      }
    })
  }



  openEditDialogRef(data?: any) {
    let dialogRef = this.dialog.open(IgrAssessmentApplicationModalComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      disableClose: true,
      panelClass: ['modal-form',],
      data,
    });

    return dialogRef;
  }


  editRole(data: any) {

    let dialogRef = this.openEditDialogRef(data);

    dialogRef.afterClosed().subscribe((result) => {

      if (result) {
        this.getFilteredApplications();
      }
    });
  }


  startInterswitch(assessment: any) {
    const assessmentEntity = assessment.entity
    const url = '/payment/initialize';
    const details = {
      paymentAmount: assessmentEntity.grossIncome,
      callbackUrl: environment.envUrl + 'admin/igr-assessment',
      email: '',
      phoneNumer: assessmentEntity.phoneNumber,
      asin: assessmentEntity?.asin || assessmentEntity.phoneNumber,
      revenueName: "Education Tax",
      entityId: assessmentEntity?.id,
      entityType: 'ASSESSMENT'
    };

    this.apiService.post(url, details).subscribe({
      next: (response) => {
        this.checkout(response.data);
      },
      error: (error) => {
        console.info(`Unable to reach Interswitch: ${error}`);
      },
    });
  }

  checkout(details: any) {
    var paymentRequest = {
      merchant_code: details?.merchantCode,
      pay_item_id: details?.payItemId,
      txn_ref: details?.orderId,
      cust_id: details?.customerId,
      amount: Math.round((details?.amount * 100 + Number.EPSILON) * 100) / 100,
      currency: '566',
      site_redirect_url: window.location.origin,

      onComplete: (response: any) => this.paymentCallback(response),
      mode: details?.mode,
    };

    if (
      details?.mode === 'LIVE' &&
      details?.splitAccounts &&
      Object.keys(details?.splitAccounts).length > 0
    ) {
      paymentRequest['split_accounts'] = JSON.stringify(details?.splitAccounts);
    }

    (window as any).webpayCheckout(paymentRequest);
  }

  // paymentCallback(response) {
  //   this.getFilteredApplications()
  // }

  paymentCallback(response: any) {

    const url = '/payment/acknowledge?orderId=' + response?.txnref;
    this.apiService.post(url, {}).subscribe(
      (response) => {
        this.getFilteredApplications();
      },
      (error) => {
        console.info(`Unable to reach Interswitch: ${error}`);
      }
    );
    return;
  }

}
